import {getCookie} from "@/assets/js/common.js";

// 海报图
export function drawPoster(data, posterMsg) {
  return new Promise(function(resolve, reject) {
    switch (data.type) {
      case "pro":
        resolve(poster(data, posterMsg));
        break;
      case "base":
        resolve(drawBasePoster(data));
        break;
      case "image":
        resolve(drawImgPoster(data));
        break;
      case "doctor":
        resolve(posterDoctor(data, posterMsg));
        break;
      default:
        resolve(poster(data));
    }
  });
}

function posterDoctor(data, posterMsg) {
  console.log(posterMsg);
  var userName = unescape(getCookie("xmh_nickname"));
  var userAvatar = getCookie("xmh_headimgurl");
  return {
    width: "254px",
    height: "420px",
    background: "#2A3F90", // 背景颜色
    views: [
      {
        type: "image",
        url: require("@/assets/images/bjDoctor/doctor_share_bg1.png"),
        css: {
          width: "254px",
          height: "420px",
          mode: "scaleToFill"
        }
      },
      {
        type: "text",
        text: posterMsg.title,
        css: {
          top: "65px",
          left: "14px",
          width: "238px",
          color: "#1D338C",
          fontSize: "22px",
          maxLines: 2,
          breakWord: true,
          lineHeight: "34px",
          bolder: true,
          fontWeight: "bold",
          textStyle: "textStroke" //文字周围白色阴影
        }
      },
      {
        type: "image",
        url: posterMsg.doctorImg,
        css: {
          top: "150px",
          left: "-10px",
          width: "150px",
          height: "250px"
        }
      },
      {
        type: "image",
        url: require("@/assets/images/bjDoctor/bottom_shade.png"),
        css: {
          bottom: "0px",
          width: "255px",
          height: "95px"
        }
      },

      {
        type: "text",
        text: posterMsg.doctorName,
        css: {
          top: "168px",
          left: "164px",
          color: "#FFFFFF",
          fontSize: "17px"
        }
      },
      {
        type: "text",
        text: `${posterMsg.hospital}   ${posterMsg.position}`,
        css: {
          top: "208px",
          left: "140px",
          color: "#AD7D32",
          fontSize: "12px",
          textDecoration: "underlineBottom",
          width: "106px",
          MaxLineNumber: "2",
          breakWord: true,
          lineHeight: "20px",
          maxLines: 4
        }
      },
      // {
      //     type:'text',
      //     text:posterMsg.position,
      //     css: {
      //         top: '250px',
      //         left: '140px',
      //         color: '#AD7D32',
      //         fontSize: '12px',
      //         textDecoration: 'underlineBottom',
      //         width: '117px',
      //         MaxLineNumber: '2',
      //         breakWord: true,
      //         lineHeight: '15px',
      //         maxLines: 4
      //     }
      // },
      {
        type: "image",
        url: userAvatar,
        css: {
          bottom: "12px",
          left: "10px",
          borderRadius: "18px",
          width: "34px",
          height: "34px"
        }
      },
      {
        type: "text",
        text: userName.length > 3 ? userName.substring(0, 8) + "..." : userName,
        css: {
          bottom: "24px",
          left: "48px",
          color: "#FFFFFF",
          fontSize: "12px",
          textDecoration: "underlineBottom"
        }
      },
      {
        type: "rect",
        css: {
          bottom: "26px",
          right: "16px",
          color: "#fff",
          width: "42px",
          height: "42px"
        }
      },
      {
        type: "qrcode",
        content:
          window.location.origin +
          (posterMsg.isExpertsView ? "/expertsView?id=" : "/bjdoctor?id=") +
          posterMsg.id +
          "&crmId=" +
          posterMsg.crmId +
          "&title=" +
          posterMsg.title, // 根据链接生成二维码
        css: {
          bottom: "28px",
          right: "18px",
          color: "#C28520",
          width: "38px",
          height: "38px"
        }
      },
      {
        type: "text",
        text: "扫码立即观看好课",
        css: {
          bottom: "12px",
          right: "8px",
          color: "#FFFFFF",
          fontSize: "8px"
        }
      }
    ]
  };
}

function poster(data, posterMsg) {
  var date = posterMsg.startTime && new Date(posterMsg.startTime.replace(/-/g, "/")) || "";
  var weekDay = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
  var userName = unescape(getCookie("xmh_nickname"));
  var userAvatar = getCookie("xmh_headimgurl");
  return {
    width: "254px",
    height: "453px",
    background: "#2A3F90", // 背景颜色
    views: [
      {
        type: "image",
        url: require("../../../assets/images/poster/bg.png")
      },
      {
        type: "text",
        text: posterMsg.title,
        css: {
          top: "60px",
          left: "10px",
          width: "238px",
          color: "#2E418B",
          fontSize: "24px",
          maxLines: 2,
          breakWord: true,
          lineHeight: "34px",
          bolder: true
        }
      },
      {
        type: "image",
        url: posterMsg.imgUrl,
        css: {
          top: "165px",
          left: "15px",
          borderRadius: "8px",
          width: "85px",
          height: "120px"
        }
      },
      {
        type: "text",
        text: posterMsg.expert.realName,
        css: {
          top: "186px",
          left: "140px",
          color: "#FFF",
          fontSize: "20px"
        }
      },
      {
        type: "text",
        text: `${posterMsg.expert.hospital} ${posterMsg.expert.position}`,
        css: {
          top: "234px",
          left: "120px",
          color: "#AD7D32",
          fontSize: "12px",
          textDecoration: "underline",
          width: "117px",
          MaxLineNumber: "2",
          breakWord: true,
          lineHeight: "15px",
          maxLines: 4
        }
      },
      {
        type: "image",
        url: userAvatar,
        css: {
          top: "292px",
          left: "25px",
          borderRadius: "18px",
          width: "26px",
          height: "26px"
        }
      },
      {
        type: "text",
        text: userName,
        css: {
          top: "296px",
          left: "58px",
          color: "#2A3F90",
          fontSize: "14px",
          textDecoration: "underline"
        }
      },
      {
        type: "text",
        text: date && "- 开课时间 -" || "",
        css: {
          top: "398px",
          left: "25px",
          color: "#FAE6AA",
          fontSize: "12px"
        }
      },
      {
        type: "text",
        text: date && `${posterMsg.startTime.slice(5, 7)}月${posterMsg.startTime.slice(
          8,
          10
        )}日` || "",
        css: {
          top: "415px",
          left: "27px",
          color: "#FAE6AA",
          fontSize: "12px",
          bolder: true
        }
      },
      {
        type: "text",
        text: date && `${weekDay[date.getDay()]} ${posterMsg.startTime.slice(10, 16)}` || "",
        css: {
          top: "428px",
          left: "24px",
          color: "#FAE6AA",
          fontSize: "12px",
          bolder: true
        }
      },
      {
        type: "rect",
        css: {
          bottom: "16px",
          right: "16px",
          color: "#fff",
          width: "40px",
          height: "40px"
        }
      },
      {
        type: "qrcode",
        content:
          window.location.host == "mom.feihe.com"
            ? "https://mom.feihe.com/course?pageSource=momclasspostscan"
            : "http://momuat.feihe.com/course?pageSource=momclasspostscan", // 根据链接生成二维码
        css: {
          bottom: "18px",
          right: "18px",
          color: "#2A3F90",
          width: "37px",
          height: "37px"
        }
      }
    ]
  };
}

function drawBasePoster() {
  return {
    width: "654px",
    height: "1000px",
    background: "#eee",
    views: [
      _textDecoration("overline", 0),
      _textDecoration("underline", 1),
      _textDecoration("line-through", 2),
      _textDecoration("overline underline line-through", 3, "red"),
      {
        type: "rect",
        css: {
          width: "200px",
          right: "20px",
          top: "30px",
          height: "100px",
          borderRadius: "100px",
          shadow: "10px 10px 5px #888888",
          color:
            "linear-gradient(-135deg, #fedcba 0%, rgba(18, 52, 86, 1) 20%, #987 80%)"
        }
      },
      {
        id: "my-text-id",
        type: "text",
        text: "fontWeight: 'bold'",
        css: [
          {
            top: `${startTop + 4 * gapSize}px`,
            shadow: "10px 10px 5px #888888",
            fontWeight: "bold"
          },
          common
        ]
      },
      {
        type: "rect",
        css: {
          width: "20px",
          height: "20px",
          color: "red",
          left: [`${startTop}px`, "my-text-id"],
          top: `${startTop + 4 * gapSize + 15}px`
        }
      },
      {
        id: "text-id-2",
        type: "text",
        text: "我是把width设置为400px后，我就换行了xx行了",
        css: [
          {
            top: `${startTop + 5 * gapSize}px`,
            align: "center",
            width: "400px",
            background: "#538e60",
            textAlign: "center",
            padding: "10px"
          },
          common,
          { left: "300px" }
        ]
      },
      {
        type: "rect",
        css: {
          width: "20px",
          height: "20px",
          color: "red",
          left: "200px",
          top: [`${startTop + 5 * gapSize}px`, "text-id-2"]
        }
      },
      {
        type: "text",
        text: "我设置了maxLines为1，看看会产生什么效果",
        css: [
          {
            top: `${startTop + 7 * gapSize}px`,
            width: "500px",
            maxLines: 1
          },
          common
        ]
      },
      _image(0),
      _des(0, "普通"),
      _image(1, 30),
      _des(1, "rotate: 30"),
      _image(2, 30, "20px"),
      _des(2, "borderRadius: 30px"),
      _image(3, 0, "60px"),
      _des(3, "圆形"),
      {
        type: "image",
        // url: require('./assets/avatar.jpg'),
        css: {
          bottom: "40px",
          left: "40px",
          borderRadius: "50px",
          borderWidth: "10px",
          borderColor: "yellow",
          width: "100px",
          height: "100px"
        }
      },
      {
        type: "qrcode",
        // content: 'https://github.com/sunnie1992/vue_canvas_poster',
        css: {
          bottom: "40px",
          left: "180px",
          color: "red",
          borderWidth: "10px",
          borderColor: "blue",
          width: "120px",
          height: "120px"
        }
      },
      {
        type: "rect",
        css: {
          bottom: "40px",
          right: "40px",
          color: "radial-gradient(rgba(0, 0, 0, 0) 5%, #0ff 15%, #f0f 60%)",
          borderRadius: "20px",
          borderWidth: "10px",
          width: "120px",
          height: "120px"
        }
      },
      {
        type: "text",
        text: "borderWidth",
        css: {
          bottom: "40px",
          right: "200px",
          color: "green",
          borderWidth: "2px"
        }
      }
    ]
  };
}

const startTop = 50;
const startLeft = 20;
const gapSize = 70;
const common = {
  left: `${startLeft}px`,
  fontSize: "40px"
};

function _textDecoration(decoration, index, color) {
  return {
    type: "text",
    text: decoration,
    css: [
      {
        top: `${startTop + index * gapSize}px`,
        color: color,
        textDecoration: decoration
      },
      common
    ]
  };
}

function _image(index, rotate, borderRadius) {
  return {
    type: "image",
    // url: require('./assets/avatar.jpg'),
    css: {
      top: `${startTop + 8.5 * gapSize}px`,
      left: `${startLeft + 160 * index}px`,
      width: "120px",
      height: "120px",
      shadow: "10px 10px 5px #888888",
      rotate: rotate,
      borderRadius: borderRadius
    }
  };
}

function _des(index, content) {
  const des = {
    type: "text",
    text: content,
    css: {
      fontSize: "22px",
      top: `${startTop + 8.5 * gapSize + 140}px`
    }
  };
  if (index === 3) {
    des.css.right = "60px";
  } else {
    des.css.left = `${startLeft + 120 * index + 30}px`;
  }
  return des;
}

function drawImgPoster() {
  return {
    width: "654px",
    height: "1140px",
    background: "#eee",
    views: [
      {
        type: "image"
        // url: require('./assets/avatar.jpg'),
      },
      {
        type: "text",
        text: "未设置height、width时",
        css: {
          right: "0px",
          top: "60px",
          fontSize: "30px"
        }
      },
      {
        type: "image",
        // url: require('./assets/avatar.jpg'),
        css: {
          width: "200px",
          height: "200px",
          top: "430px"
        }
      },
      {
        type: "text",
        text: "mode: 'aspectFill' 或 无",
        css: {
          left: "210px",
          fontSize: "30px",
          top: "490px"
        }
      },
      {
        type: "image",
        // url: require('./assets/avatar.jpg'),
        css: {
          width: "200px",
          height: "200px",
          mode: "scaleToFill",
          top: "650px"
        }
      },
      {
        type: "text",
        text: "mode: 'scaleToFill'",
        css: {
          left: "210px",
          top: "710px",
          fontSize: "30px"
        }
      },
      {
        type: "image",
        // url: require('./assets/avatar.jpg'),
        css: {
          width: "200px",
          height: "auto",
          top: "870px"
        }
      },
      {
        type: "text",
        text: "设置height为auto",
        css: {
          left: "210px",
          top: "930px",
          fontSize: "30px"
        }
      }
    ]
  };
}
